import { unp_json } from '$lib/static/unp_json.js'

/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
    return (typeof param === 'string' && (param === '-' || param.toUpperCase() in unp_json));
}
